import Utils from "../../../../../shared/utils"

export const TITLE = `למה WeCheck?`

export const CONTENT = `WeCheck היא חברה מבוססת על אנשי מקצוע מנוסים, בעלי ידע פיננסי וטכנולוגי מוכח, מה שמאפשר לנו להציע פתרונות חדשניים וייחודיים שלא היו זמינים עד היום, אשר עונים בצורה מדויקת על מגוון צרכים של משכירים ושוכרים. יצרנו שותפות עם יד2 וישראכרט כדי להעמיד לרשותכם גוף פיננסי מבוסס ואמין שבאמת יכול לסייע לכם במגוון אתגרים בתחום הנדל"ן. הפתרון לכאב הראש שלכם בהשכרת דירה ו/או בשכירתה מתחיל עם שירות הדאבל צ'ק החינמי שלנו.`

export const CTA_TITLE = `יש לכם דיירים פוטנציאלים? למה אתם מחכים?`

export const IMAGE_URL = Utils.buildProductPageImageLink("rent/doublecheck/fourth-section-desk.png")